import React from 'react';
import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
  LocalizationProvider,
  DateTimePicker,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import moment from 'moment';

const CustomDateTimePicker = ({
  label,
  value,
  onChange,
  disabled = false,
  isValidDate,
  placeholder = 'Select',
  sx,
  ampm= false,
  mode = 'datetime', 
  ...props
}) => {
  const commonProps = {
    label,
    value: value ? moment(value) : null,
    onChange: (newValue) => onChange(newValue),
    disabled,
    shouldDisableDate: isValidDate,
    ampm: false,
    renderInput: (params) => (
      <TextField
        {...params}
        placeholder={placeholder}
        sx={{
          ...sx,
          '& .MuiInputBase-root': {
            height: '44px',
            borderRadius: '10px',
            border: '1px solid #D9D9D9',
            backgroundColor: '#F9F9F9',
          },
          '& .MuiInputBase-input': {
            padding: '0 14px',
          },
        }}
      />
    ),
    ...props,
  };

  const getPickerComponent = () => {
    switch (mode) {
      case 'date':
        return <DatePicker {...commonProps} />;
      case 'time':
        return <TimePicker {...commonProps} />;
      default:
        return <DateTimePicker {...commonProps} />;
    }
  };

  return <LocalizationProvider dateAdapter={AdapterMoment}>{getPickerComponent()}</LocalizationProvider>;
};

export default CustomDateTimePicker;